import React, { useState } from "react";
import { Col, Form, Modal, Row, InputGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import {
  SendOtpEmail,
  VerifyOtpEmail,
  ForgetPasswordEmail,
} from "../../../features/common/Slice";
import Blue_border_button from "../../../components/common_components/common_btn/blue_border_button/Blue_border_button";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import successAnimation from "../../../components/animation/success_lottie/Success_lottie.json";
import Success_modal from "../../../components/common_components/common_modal/success_modal/Success_modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const ForgetPassword = ({ show, onHide, setShow, selectedPartner, email }) => {
  console.log(selectedPartner, "selectedPartner");
  console.log(email, "email");

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    getValues,
    watch,
    formState: { errors, isSubmitting },
  } = useForm();

  const [otpVerified, setOtpVerified] = useState(false);
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  let role_id = "";

  if (selectedPartner == "admin") {
    role_id = 1;
  } else if (selectedPartner == "college ") {
    role_id = 2;
  } else if (selectedPartner == "hotel") {
    role_id = 3;
  } else if (selectedPartner == "student") {
    role_id = 4;
  }

  const dispatch = useDispatch();

  const passwordValue = watch("password");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("email_or_contact", email);
      sendData.append("password", data.password);

      const res = await dispatch(ForgetPasswordEmail(sendData));

      console.log(res, "res");

      if (res?.meta?.requestStatus === "fulfilled") {
        setShow(false);
        onHide(true);
        setModalsuccessShow(true);

        setTimeout(() => {
          setModalsuccessShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Reset password error:", error);
    }
  };

  const EmailVerify = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("contact_no", email);
      sendData.append("otp", data.otp);

      const res = await dispatch(VerifyOtpEmail(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalsuccessShow(true);
        setOtpVerified(true);

        setTimeout(() => {
          setModalsuccessShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      className="ForgetPasswordEmail_modal "
    >
      <Modal.Header closeButton>
        <Modal.Title>Forget Password</Modal.Title>
      </Modal.Header>

      {/* ✅ Form must wrap everything */}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="form_holder">
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={email}
                    disabled
                    {...register("email", {})}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Otp</Form.Label>
                  <div className="otp_field_holder">
                    <Form.Control
                      placeholder="Enter otp"
                      className={classNames({
                        "is-invalid": errors?.otp,
                      })}
                      disabled={otpVerified ? true : false}
                      {...register("otp", {
                        required: "OTP is required",
                        minLength: {
                          value: 4,
                          message: "OTP must be at least 4 digits",
                        },
                      })}
                    />

                    {!otpVerified ? (
                      <Col>
                        <button
                          type="button"
                          onClick={async () => {
                            const isOtpValid = await trigger("otp");
                            if (isOtpValid) {
                              EmailVerify({ otp: getValues("otp") });
                            }
                          }}
                          className="otp_button"
                        >
                          Verify OTP
                        </button>
                      </Col>
                    ) : (
                      <>
                        <FontAwesomeIcon
                          className="verified_icon"
                          icon={faCircleCheck}
                        />
                      </>
                    )}
                  </div>

                  {errors?.otp && (
                    <Form.Text className="text-danger">
                      {errors.otp.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Password</Form.Label>

                  <InputGroup>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      className={classNames({
                        "is-invalid": errors?.password,
                      })}
                      {...register("password", {
                        required: "Password is required",
                        pattern: {
                          value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                          message:
                            "Password must be 8+ chars, include uppercase, lowercase, number & special character",
                        },
                      })}
                    />

                    <InputGroup.Text
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </InputGroup.Text>
                  </InputGroup>

                  {errors?.password && (
                    <Form.Text className="text-danger">
                      {errors.password.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* Confirm Password */}
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group className="form_field">
                  <Form.Label>Confirm Password</Form.Label>

                  <InputGroup>
                    <Form.Control
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Enter Confirm Password"
                      className={classNames({
                        "is-invalid": errors?.confirm_password,
                      })}
                      {...register("confirm_password", {
                        required: "Confirm Password is required",
                        validate: (value) =>
                          value === passwordValue || "Passwords do not match",
                      })}
                    />

                    <InputGroup.Text
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </InputGroup.Text>
                  </InputGroup>

                  {errors?.confirm_password && (
                    <Form.Text className="text-danger">
                      {errors.confirm_password.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Col className="text-center">
            <Blue_border_button
              button_text={isSubmitting ? "Sending..." : "Update Password"}
              type="submit"
              disabled={isSubmitting}
            />
          </Col>
        </Modal.Footer>
      </Form>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </Modal>
  );
};

export default ForgetPassword;
